<template>
  <div class="loading-display">
    <slot></slot>
  </div>
</template>
<style scoped>
.loading-display {
  display: flex;
  width: 100%;
  height: 100%;
  padding: 20px;
  text-align: center;
  align-items: center;
  vertical-align: middle;
  justify-content: center;
}
</style>
